module.exports = __webpack_public_path__ + "static/media/young8_s.2349c356.jpg";